import { useMemo } from 'react';
import { scaleLinear } from '@visx/scale';

import { PATH_STROKE_DELTA } from '@components/patterns/LineChart/constants';
import { Measurement } from '@components/patterns/LineChart/types';
import { UseDataMeta } from '@components/patterns/LineChart/use-data';

export interface UseScalesResult {
  index: ReturnType<typeof scaleLinear<number>>;
  x: ReturnType<typeof scaleLinear<number>>;
  y: ReturnType<typeof scaleLinear<number>>;
}

export function useScales(
  { minIndex, maxIndex, minX, maxX, minY, maxY }: UseDataMeta,
  rect: Measurement
) {
  return useMemo(() => {
    const x0 = rect.marginLeft + PATH_STROKE_DELTA;
    const x1 = Math.max(
      0,
      rect.marginLeft + rect.innerWidth - PATH_STROKE_DELTA
    );

    const y0 = Math.max(
      0,
      rect.marginTop + rect.innerHeight - PATH_STROKE_DELTA
    );
    const y1 = rect.marginTop + PATH_STROKE_DELTA;

    const index = scaleLinear({
      domain: [minIndex, maxIndex + 1],
      range: [x0, x1],
    });

    const x = scaleLinear({
      domain: [minX, maxX],
      range: [x0, x1],
    });

    const y = scaleLinear({
      nice: true,
      domain: [minY, maxY],
      range: [y0, y1],
    });
    return { index, x, y };
  }, [minIndex, maxIndex, minX, maxX, minY, maxY, rect]);
}
